import * as CollapsePrimitive from '@radix-ui/react-collapsible';
import { keyframes, styled } from '../../system';
import { wrapWithDefaultProps } from '../../lib/wrap-with-default-props';
const openKeyframes = keyframes({
    from: { height: 0 },
    to: { height: 'var(--radix-collapsible-content-height)' }
});
const closeKeyframes = keyframes({
    from: { height: 'var(--radix-collapsible-content-height)' },
    to: { height: 0 }
});
const StyledCollapse = styled(CollapsePrimitive.Root, {});
const StyledContent = styled(CollapsePrimitive.Content, {
    overflow: 'hidden',
    '@media (prefers-reduced-motion: no-preference)': {
        willChange: 'height',
        '&[data-state="open"]': { animation: `${openKeyframes} 200ms ease-out` },
        '&[data-state="closed"]': { animation: `${closeKeyframes} 200ms ease-out` }
    }
});
const StyledTrigger = styled(CollapsePrimitive.Trigger, {});
export const Collapse = StyledCollapse;
export const CollapseTrigger = wrapWithDefaultProps(StyledTrigger, {
    asChild: true
});
export const CollapseContent = StyledContent;
